"use client";
import { useEmployeeUserDetails } from "@/hooks/employeesHook";
import { UserOutlined } from "@ant-design/icons";
import { Typography, Avatar, Skeleton } from "antd";
import style from "./style.module.scss";
import UserPlaceholder from "@/Assets/Images/userplaceholder.png"

const { Paragraph } = Typography;

interface DriverIdInterface {
  driverId: string;
  showDriverId?: boolean;
  key?: string;
  showShortDriverID?: boolean;
}

const UserInfo: React.FC<DriverIdInterface> = ({
  driverId,
  showDriverId = false,
  showShortDriverID = false,
}) => {
  const { data, isLoading } = useEmployeeUserDetails(driverId);
  const userInfo = data?.data?.data?.social || {};

  const fullName = [userInfo.first_name, userInfo.last_name].filter(Boolean).join(" ") || driverId;
  const profilePicUrl = userInfo.profile_pic_url || UserPlaceholder.src;
  const shortDriverId = driverId ? `+${driverId.slice(-4)}` : "";

  return (
    <div className={style.userInfoContainer}>
      {isLoading ? (
        <Skeleton paragraph={{ rows: 0 }} active avatar />
      ) : (
        <div className={style.userInfo}>
          {driverId && (
            <Avatar
              src={profilePicUrl}
              className={style.userProfile}
              size={35}
              icon={<UserOutlined />}
            />
          )}
          <div className={style.userInfoName}>
            <Paragraph>
              {fullName}
            </Paragraph>
            {showDriverId && driverId && (
              <Paragraph
                className={style.driverShortID}
                copyable={!!driverId ? { text: driverId } : false}
              >
                {showShortDriverID ? shortDriverId : driverId}
              </Paragraph>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserInfo;
